import AmexNAA from './AmexNAA';

export default AmexNAA;
